module.exports = __webpack_public_path__ + "static/hinted-SnellRoundhand-Black.05f8989e.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/hinted-SnellRoundhand-Black.eot
// module id = 212
// module chunks = 104101334113578 114276838955818